import React from 'react';

import { ThreeStepCtaBlockData } from 'api/cms';
import { AmpCardsBlock } from 'cms/blocks/Amp/AmpCardsBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpThreeStepCtaBlock({
  content,
  blockId,
  data,
}: AmpBlockMappingComponentProps<ThreeStepCtaBlockData>) {
  return (
    <AmpCardsBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        headline: data.mainHeadline,
        subheadline: data.mainText,
        buttonText: data.buttonText,
        buttonUrl: data.buttonUrl,
        cards: [
          {
            image: data.stepOneImage,
            headline: data.stepOneHeadline,
            text: data.stepOneText,
            url: data.stepOneUrl,
          },
          {
            image: data.stepTwoImage,
            headline: data.stepTwoHeadline,
            text: data.stepTwoText,
            url: data.stepTwoUrl,
          },
          {
            image: data.stepThreeImage,
            headline: data.stepThreeHeadline,
            text: data.stepThreeText,
            url: data.stepThreeUrl,
          },
        ],
      }}
    />
  );
}
